import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CheckoutStatus, CreateOrderRequest, NativeOrderStatus, OrderStatus } from '~models';
import { CheckoutV2Service, LoaderService } from '~services';

@Component({
  selector: 'app-native-checkout-callback-view',
  template: ``,
})
export class NativeCheckoutCallbackViewComponent implements OnInit, OnDestroy {
  constructor(
    private checkoutV2Service: CheckoutV2Service,
    private activatedRoute: ActivatedRoute,
    private loaderService: LoaderService,
  ) {}

  ngOnDestroy(): void {
    this.loaderService.hide();
  }

  async ngOnInit(): Promise<void> {
    this.loaderService.show(
      'We are currently processing your gift card order. <br>Please do not close this window.',
    );
    const orderStatus = await this.createOrder();
    console.info(`Order status: ${orderStatus}`);
    // TODO: Add deeplink - window.location.href = `${deeplink}`;
  }

  async createOrder(): Promise<NativeOrderStatus> {
    if (!this.orderId || !this.checkoutId) {
      return OrderStatus.FAILED;
    }

    if (this.isCheckoutCancelled) {
      return CheckoutStatus.CHECKOUT_CANCELLED;
    }

    if (!this.isCheckoutSuccessful) {
      return CheckoutStatus.CHECKOUT_FAILED;
    }

    const createOrderRequest: CreateOrderRequest = {
      orderId: this.orderId,
      checkoutId: this.checkoutId,
    };

    try {
      const order = await this.checkoutV2Service.createOrder(createOrderRequest);
      return order.status;
    } catch (error) {
      window.zbm?.reportError(error);
      return OrderStatus.FAILED;
    }
  }

  private get orderId(): string | undefined {
    return this.activatedRoute.snapshot.queryParams.orderId;
  }

  private get checkoutId(): string | undefined {
    return this.activatedRoute.snapshot.queryParams.checkoutId;
  }

  private get isCheckoutSuccessful(): boolean {
    return this.activatedRoute.snapshot.queryParams.result === 'approved';
  }

  private get isCheckoutCancelled(): boolean {
    return this.activatedRoute.snapshot.queryParams.result === 'cancelled';
  }
}
